import { BasicCard as Basic } from './BasicCard';
import { StaticCard as Static } from './StaticCard';

export type { IBasicCardProps } from './BasicCard';
export type { IStaticCardProps } from './StaticCard';

export const Card = {
  Basic,
  Static
};
